//#region IMPORT
import { useRef, useState } from 'react';
import TRA_NEW_01 from './TRA_NEW_01';
import { useNavigate } from 'react-router-dom';
import Commons from '../../../../../Services/Common/Common';
import Global from '../../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../../Reducer/SnackbarReducer';
import {
  closeLoading,
  showLoading,
} from '../../../../../Reducer/LoadingReducer';
import dayjs from 'dayjs';
import {
  useSearch1,
  useSearch2,
  useSearch3,
  useSearch4,
} from './TRA_NEW_01_QUERY';
//#endregion

function TRA_NEW_01F(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);
  //교육현황 그리드
  const gridRef1 = useRef();
  const [rowData1, setRowData1] = useState([]); // 교육현황 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 교육현황 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 교육현황 그리드 변경 시 데이터
  //참석자정보 그리드
  const gridRef2 = useRef();
  const [rowData2, setRowData2] = useState([]); // 참석자정보 그리드 데이터
  const [selectedRowData2, setSelectedRowData2] = useState([]); // 참석자정보 그리드 클릭 시 데이터
  const [changedRowData2, setChangedRowData2] = useState([]); // 참석자정보 그리드 변경 시 데이터
  const tbmCdRef = useRef(''); // 셀 클릭 시 tbmCd
  const [modalToggle1, setModalToggle1] = useState(false);
  const [modalSearchText, setModalSearchText] = useState(''); // 팝업 검색 텍스트
  const [selectedModalRowData1, setSelectedModalRowData1] = useState([]); // 팝업 선택된 행 데이터
  const selectedRowNosRef = useRef(new Set());
  const currentRowIndexRef = useRef(null);
  const lastCheckedIndexRef = useRef(null);
  //#endregion

  //#region 조회
  //교육현황 조회(_value1:사업장코드)
  const { refetch: Search1 } = useSearch1({
    onSuccess: async (rows) => {
      setRowData1(rows);
    },
    enabled: !props.allMemberView1,
  });
  const { run: Search2, runAsync: Search2Async } = useSearch2({
    onSuccess: (rows) => {
      setRowData2(rows);
    },
  });
  const { runAsync: Search3Async } = useSearch3();
  const { runAsync: Search4Async } = useSearch4();

  //#endregion
  //#region 나머지 함수
  const NormalizeMemberRows = (rows = []) =>
    rows.map((row, index) => ({
      ...row,
      no: row.no ?? index + 1,
      userId:
        row.userId ??
        row.UserId ??
        row.USER_ID ??
        row.USERID ??
        row.id ??
        row.Id ??
        row.ID ??
        '',
      name: row.name ?? row.userNm ?? row.Name ?? '',
      depNm: row.depNm ?? row.DepNm ?? row.DEP_NM ?? '',
      affiliationNm:
        row.affiliationNm ?? row.AffiliationNm ?? row.AFFILIATION_NM ?? '',
      internalYn: String(
        row.internalYn ?? row.InternalYn ?? row.INTERNAL_YN ?? '0'
      ),
      rank:
        row.rank ??
        row.Rank ??
        row.position ??
        row.Position ??
        row.POSITION ??
        '',
      tbmAddDate: row.tbmAddDate ?? 0,
      achievementRate: row.achievementRate ?? 0,
    }));

  const SearchLogic1 = async () => {
    if (props.allMemberView1) {
      const [memberRows, trainingRows] = await Promise.all([
        Search3Async({
          search: searchInfo,
          userInfo,
        }),
        Search4Async({
          search: searchInfo,
          userInfo,
        }),
      ]);

      const normalizedMembers = NormalizeMemberRows(memberRows);
      const trainingMap = new Map(
        (trainingRows || []).map((row) => [
          String(row.userId ?? row.UserId ?? row.USER_ID ?? row.USERID ?? ''),
          row,
        ])
      );

      const mergedRows = normalizedMembers.map((row) => {
        const training = trainingMap.get(String(row.userId)) || {};
        return {
          ...row,
          tbmAddDate:
            training.tbmAddDate ?? training.TbmAddDate ?? row.tbmAddDate ?? 0,
          achievementRate:
            training.achievementRate ??
            training.AchievementRate ??
            row.achievementRate ??
            0,
        };
      });

      setRowData1(mergedRows);
      setRowData2([]);
      return;
    }

    await Search1();
    setRowData2([]);
  };

  const fixUrl = (url) => {
    if (!url || typeof url !== 'string') return '';
    const parts = url.split('/');
    const fileName = parts.pop();
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  };

  const getBase64ImageSafe = async (url) => {
    try {
      if (!url || typeof url !== 'string' || url.trim() === '') {
        return null;
      }

      const fullUrl = url.startsWith('http')
        ? url
        : `${Global.file.useUrl}files/${fixUrl(url)}`;

      const response = await fetch(fullUrl, {
        method: 'GET',
        cache: 'no-cache',
      });

      if (!response.ok) {
        console.warn('파일 없음 또는 접근 불가:', fullUrl, response.status);
        return null;
      }

      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.startsWith('image/')) {
        console.warn('이미지 파일이 아님:', fullUrl, contentType);
        return null;
      }

      const blob = await response.blob();
      if (blob.size === 0) {
        console.warn('빈 파일:', fullUrl);
        return null;
      }

      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (e) {
      console.warn('이미지 변환 오류:', e);
      return null;
    }
  };

  //인쇄 함수
  const PrintLogic1 = async () => {
    // 선택된 행 확인
    if (!selectedRowData1 || selectedRowData1.length === 0) {
      dispatch(
        showSnackbar({
          message: '인쇄할 항목을 선택하세요.',
          type: 'warning',
        })
      );
      return Promise.resolve(); // Promise를 반환하여 finally가 실행되도록 함
    }

    dispatch(showLoading());
    try {
      const printYear =
        searchInfo?.year != null && String(searchInfo.year) !== ''
          ? String(searchInfo.year)
          : dayjs().format('YYYY');
      const printMonth =
        searchInfo?.month != null && String(searchInfo.month) !== ''
          ? String(searchInfo.month).padStart(2, '0')
          : dayjs().format('MM');

      const year = printYear;
      const month = printMonth;

      // 일자 포맷팅 함수 (YYYY-MM-DD)
      const FormatDate = (dateValue) => {
        if (!dateValue) return '';
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return '';

        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
      };

      // 시간 포맷팅 함수 (HH:mm)
      const FormatTime = (dateValue) => {
        if (!dateValue) return '';
        const date = new Date(dateValue);
        if (isNaN(date.getTime())) return '';

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${hours}:${minutes}`;
      };

      // 실시 시간(분) 포맷팅 함수 (초를 분으로 변환)
      const FormatDuration = (seconds) => {
        if (!seconds || seconds === 0) return '0분';

        const totalMinutes = Math.floor(Number(seconds) / 60);
        if (totalMinutes <= 0) return '0분';

        const hours = Math.floor(totalMinutes / 60);
        const remainMin = totalMinutes % 60;

        let result = '';
        if (hours > 0) result += `${hours}시간 `;
        if (remainMin > 0) result += `${remainMin}분`;
        return result.trim();
      };

      // 누계시간 포맷팅 함수 (초를 시간/분으로 변환)
      const FormatTotalTime = (seconds) => {
        if (!seconds || seconds === 0) return '0분';

        const totalMinutes = Math.floor(Number(seconds) / 60);
        if (totalMinutes <= 0) return '0분';

        const hours = Math.floor(totalMinutes / 60);
        const remainMin = totalMinutes % 60;

        let result = '';
        if (hours > 0) result += `${hours}시간 `;
        if (remainMin > 0) result += `${remainMin}분`;
        return result.trim();
      };

      let queriedWithValidUser = false;
      let hadAnyDetailRows = false;

      // selectedRowData1의 각 항목에 대해 반복하여 조회 및 인쇄
      for (const selectedRow of selectedRowData1) {
        if (!selectedRow.userId) continue;

        queriedWithValidUser = true;
        const userId = selectedRow.userId;

        // useSearch2 훅의 runAsync를 사용하여 데이터 조회
        const searchData = await Search2Async(
          {
            search: {
              year: printYear,
              month: printMonth,
            },
            userId: userId,
          },
          {} // onSuccess 콜백 없이 데이터만 반환받기 위해 빈 객체 전달
        );

        if (searchData && searchData.length > 0) {
          hadAnyDetailRows = true;
          const tableData = await Promise.all(
            searchData.map(async (row) => {
              const signaturePath = row.signImagePath ?? '';
              let signatureBase64 = '';
              if (signaturePath) {
                try {
                  const base64Full = await getBase64ImageSafe(signaturePath);
                  if (base64Full && base64Full.startsWith('data:image/')) {
                    signatureBase64 = base64Full.replace(
                      /^data:image\/[a-z]+;base64,/,
                      ''
                    );
                  }
                } catch {
                  /* empty */
                }
              }

              return {
                ...row,
                DEP_NM: row.depNm,
                POSITION: row.position,
                NAME: row.name,
                TBM_DATE: FormatDate(row.tbmDate),
                TBM_START_DATE: FormatTime(row.tbmStartDate),
                TBM_END_DATE: FormatTime(row.tbmEndDate),
                TBM_ADD_DATE: FormatDuration(row.tbmAddDate),
                TOTAL_TIME: FormatTotalTime(row.totalTime),
                REMARK: row.remark,
                SIGN_IMAGE_PATH: signatureBase64,
              };
            })
          );

          // 각 항목마다 별도로 인쇄
          const printData = {
            FileName: 'TRA_NEW_01',
            HeaderData: JSON.stringify({
              YEAR: year,
              MONTH: month,
            }),
            TableData: JSON.stringify(tableData),
          };

          await Commons.Axios(
            'report',
            Global.base.useUrl + Global.urls.Reports.reports,
            printData
          ).then((response) => {
            const blobUrl = URL.createObjectURL(response.data);
            window.open(blobUrl, '_blank'); // 새 탭에서 열기
          });
        }
      }

      if (queriedWithValidUser && !hadAnyDetailRows) {
        dispatch(
          showSnackbar({
            message:
              '현재 조회 기간에 선택한 인원의 TBM 교육 기록이 없어 인쇄하지 않았습니다. 기간 또는 대상을 확인해 주세요.',
            type: 'info',
          })
        );
      }
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoading());
    }
  };

  const ResetLogic1 = () => {
    setRowData1([]);
    setRowData2([]);
    setSelectedModalRowData1([]);
  };

  const HandleRowSelection = (rowData, rowIndex) => {
    currentRowIndexRef.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  return (
    <TRA_NEW_01
      navigate={navigate}
      userInfo={userInfo}
      lanInfo={lanInfo}
      rowData1={rowData1}
      setRowData1={setRowData1}
      selectedRowData1={selectedRowData1}
      setSelectedRowData1={setSelectedRowData1}
      changedRowData1={changedRowData1}
      setChangedRowData1={setChangedRowData1}
      rowData2={rowData2}
      setRowData2={setRowData2}
      selectedRowData2={selectedRowData2}
      setSelectedRowData2={setSelectedRowData2}
      changedRowData2={changedRowData2}
      setChangedRowData2={setChangedRowData2}
      selectedRowNosRef={selectedRowNosRef}
      searchRef={props.searchRef}
      filterClick1={props.filterClick1}
      setFilterClick1={props.setFilterClick1}
      searchClick1={props.searchClick1}
      setSearchClick1={props.setSearchClick1}
      addClick1={props.addClick1}
      setAddClick1={props.setAddClick1}
      saveClick1={props.saveClick1}
      setSaveClick1={props.setSaveClick1}
      deleteClick1={props.deleteClick1}
      setDeleteClick1={props.setDeleteClick1}
      printClick1={props.printClick1}
      setPrintClick1={props.setPrintClick1}
      gridRef1={gridRef1}
      gridRef2={gridRef2}
      tbmCdRef={tbmCdRef}
      modalToggle1={modalToggle1}
      setModalToggle1={setModalToggle1}
      modalSearchText={modalSearchText}
      setModalSearchText={setModalSearchText}
      selectedModalRowData1={selectedModalRowData1}
      setSelectedModalRowData1={setSelectedModalRowData1}
      lastCheckedIndexRef={lastCheckedIndexRef}
      // 함수
      validateSelection={props.validateSelection}
      ResetLogic1={ResetLogic1}
      SearchLogic1={SearchLogic1}
      SearchLogic2={Search2}
      PrintLogic1={PrintLogic1}
      HandleRowSelection={HandleRowSelection}
      allMemberView1={props.allMemberView1}
    />
  );
}

export default TRA_NEW_01F;
